var ScalarMode = {
  NONE: 0,
  COLORS: 1,
  LABELS: 2
};
var Constants = {
  ScalarMode: ScalarMode
};

export { ScalarMode, Constants as default };
